import { render, staticRenderFns } from "./advantages.vue?vue&type=template&id=d8b980b2&scoped=true"
import script from "./advantages.vue?vue&type=script&lang=js"
export * from "./advantages.vue?vue&type=script&lang=js"
import style0 from "./advantages.vue?vue&type=style&index=0&id=d8b980b2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8b980b2",
  null
  
)

export default component.exports